(function () {
  if (window.location.pathname !== '/pages/hsa-fsa') return;

  // var BAND_URL = 'https://humehealth.com/pages/hume-bandv2?utm_source=hsa_fsa_page&utm_medium=eligible_products&utm_campaign=hsa_fsa&utm_content=hume_band_2_0_cta';
  // var POD_URL = 'https://humehealth.com/pages/hume-body-pod?utm_source=hsa_fsa_page&utm_medium=eligible_products&utm_campaign=hsa_fsa&utm_content=hume_pod_cta';
  var BAND_IMG = 'https://humehealth.com/cdn/shop/files/image-158.png?v=1779207071&width=1024';
  var POD_IMG = 'https://humehealth.com/cdn/shop/files/Hero1.webp?v=1781694322&width=1024';
  var STICKY_ID = 'hsa-mobile-sticky-cta-js';
  var STYLE_ID = 'hsa-mobile-sticky-cta-style-js'; 

  function productTarget() {
    return document.getElementById('hsa-fsa-products') || document.querySelector('.hsa-fsa-products');
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function scrollProgress() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 0;
    return window.scrollY / scrollable;
  }

  function injectStickyStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#' + STICKY_ID + '{display:none}',
      '@media screen and (max-width:749px){',
      '#' + STICKY_ID + '{position:fixed;left:16px;right:16px;bottom:calc(16px + env(safe-area-inset-bottom));z-index:9999;align-items:center;justify-content:center;min-height:52px;padding:14px 18px;border-radius:8px;background:#116ad6;color:#fff;font-family:Montserrat,sans-serif;font-size:16px;font-weight:700;line-height:1.2;letter-spacing:0;text-align:center;text-decoration:none;box-shadow:0 14px 34px rgba(17,106,214,.32);opacity:0;pointer-events:none;transform:translateY(14px);transition:opacity 180ms ease,transform 180ms ease}',
      '#' + STICKY_ID + '.is-visible{display:flex;opacity:1;pointer-events:auto;transform:translateY(0)}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureStickyCta() {
    var sticky = document.getElementById(STICKY_ID);
    if (sticky) return sticky;
    sticky = document.createElement('a');
    sticky.id = STICKY_ID;
    sticky.href = '#hsa-fsa-products';
    sticky.textContent = 'Shop HSA/FSA Eligible Products';
    sticky.setAttribute('aria-label', 'Scroll to HSA/FSA eligible products');
    document.body.appendChild(sticky);
    sticky.addEventListener('click', function (event) {
      var target = productTarget();
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return sticky;
  }

  function updateSticky() {
    var sticky = document.getElementById(STICKY_ID);
    if (!sticky) return;
    if (isMobile() && scrollProgress() >= 0.18) {
      sticky.classList.add('is-visible');
    } else {
      sticky.classList.remove('is-visible');
    }
  }

  function applyProductUtms() {
    var cards = document.querySelectorAll('.hsa-fsa-products .hsa_products-details');
    cards.forEach(function (card) {
      var title = card.querySelector('.hsa_product_title');
      var link = card.querySelector('a[href]');
      if (!title || !link) return;
      var name = title.textContent.trim().toLowerCase();
      if (name.indexOf('band') !== -1) {
        // link.href = BAND_URL;
        title.textContent = 'Hume Band';
        updateProductImage(card, BAND_IMG, 'Hume Band 2.0');
      } else if (name.indexOf('pod') !== -1) {
        // link.href = POD_URL;
        title.textContent = 'The Hume Pod';
        updateProductImage(card, POD_IMG, 'The Hume Pod');
      }
      removeInjectedProductCtas(card);
    });
  }

  function updateProductImage(card, src, alt) {
    var image = card.querySelector('.hsa-images img');
    if (!image) return;
    image.src = src;
    image.srcset = '';
    image.alt = alt;
  }

  function removeInjectedProductCtas(card) {
    card.querySelectorAll('.hsa-product-card-cta').forEach(function (cta) {
      cta.remove();
    });
  }

  function initHsaFsaHelpers() {
    injectStickyStyle();
    ensureStickyCta();
    applyProductUtms();
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    window.setTimeout(applyProductUtms, 750);
    window.setTimeout(updateSticky, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHsaFsaHelpers);
  } else {
    initHsaFsaHelpers();
  }
})();
